import * as React from "react";
import Collapsible from "react-collapsible";
import {FormattedMessage} from 'react-intl';
import { Link, NavLink } from "react-router-dom";
import { nodeType as Type } from "../../constants/NodeTypes";
import GeneratorEntity from "../../models/Generator";
import userManager from "../../utils/userManager";
import translations from './translations';
import { Treenode } from "./treenode";

interface IProps {
  generatorList: GeneratorEntity[];

  updateNodeData: (displayName: string, propertyname: string, nodetype: string) => void;
}

let currentPath: string="";

let menuTree: any = [];

export class SidebarComponent extends React.Component<IProps, {}> {

  constructor(props: any) {
    super(props);
    this.onToggle = this.onToggle.bind(this);
  }

  public handleLogout = () => {
    userManager.signoutRedirect();
  };

  public onToggle(node: any, toggled: any) {
    node.active = true;
    if (node.children) {
      node.toggled = toggled;
    }
    this.setState({ cursor: node });
  }


  public ExportPaths() {

    const generators = this.props.generatorList;
    const result = {};
    for (const index in generators) {
      // tslint:disable-line

      const gen = generators[index]; // loop through all generators in list

      if (gen.path !== null) {
        const path = "/" + gen.path + "/";
        result[path] = [];
      }
    }

    const paths = Object.keys(result);
    this.ArrangeIntoTree(paths);

    // Make TreeMenu
  }

  public ArrangeIntoTree(paths: string[]) {
    menuTree=[];
    paths.forEach(path => {
      const pathParts = path.split("/");
      pathParts.shift(); // Remove first blank element from the parts array.
      let currentLevel = menuTree; // initialize currentLevel to root
      pathParts.forEach(part => {
        // check to see if the path already exists.
        const existingPath = currentLevel.filter((level: any) => level.name === part);

        if (existingPath.length > 0) {
          // The path to this item was already in the tree, so don't add it again.
          currentLevel = existingPath[0].children; // Set the current level to this path's children
        } else {
          const newPart = {
            name: part,
            children: [], // tslint:disable-line
            diplayName: part,
            curPath: this.reducePath(path, part)
          };
          currentLevel.push(newPart);
          currentLevel = newPart.children;
        }
      });
    });

    return menuTree;
  }

public reducePath(path: string, last: string){

  const pathParts = path.split("/");
  let newPath = "/";
  for (const singlepath in pathParts) {

    if (pathParts[singlepath] !== last) {
      newPath=newPath + "/" + pathParts[singlepath];
    } else {
      newPath=newPath + "/" + pathParts[singlepath] + "/";
      break;
    }

  }
  newPath = newPath.substr(2)
  return newPath;
}

  public countInstances(cstring: any, word: any) {
    return cstring.split(word).length - 1;
  }

  public LoopJSON() {
    const generators = this.props.generatorList;
    const result = {};
    for (const index of Object.keys(generators)) {
      // loop through all generators in list
      const gen = generators[index];
      const cat = gen.categories;
      if (cat) {
        // check, if categories exist
        for (const c in cat) {
          // loop through all categories in current list
          if (result[cat[c]]) {
            result[cat[c]].push(gen.name);
          } else {
            result[cat[c]] = [];
            result[cat[c]].push(gen.name);
          }
        }
      }
    }
    let newResult = result;
    newResult = this.sortObject(result);
    return newResult;
  }
  
  public sortObject(obj: any) {
    const newKeys = Object.keys(obj);
    newKeys.sort((a: any, b: any) => {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    return newKeys.reduce((a, v) => {
      a[v] = obj[v];
      return a;
    }, {});
  }
  
  public GetGeneratorByName(geno: any): any {
    const generators = this.props.generatorList;
    for (const gen in generators) {
      if (generators[gen].name === geno) {
        return generators[gen];
      }
    }
  }

  public TraverseTree(branch: any) {

    let displayName: string = "";
    const nodeType: string = "folder";
    for (const key in branch) {// tslint:disable-line
      displayName=branch[key].name
      currentPath = branch[key].curPath;
      break;
    }
    this.props.updateNodeData(displayName, currentPath, nodeType);

  }

  public GetChildren(branch: any) {
    for (const key in branch) {

      if (branch[key].children.length > 0) {
        const a: any = branch[key].children;
        this.GetChildren(a);
      }
    }
  }

  public GetGeneratorsByCategory(name: string) {
    const generators = this.props.generatorList;
    const result = {};
    for (const index in generators) {
      // tslint:disable-line
      // loop through all generators in list
      const gen = generators[index];
      const cat = gen.categories;
      if (cat) {
        // check, if categories exist
        for (const c in cat) {
          // loop through all categories in current list
          if (result[cat[c]]) {
            result[cat[c]].push(gen.name);
          } else {
            result[cat[c]] = [];
            result[cat[c]].push(gen.name);
          }
        }
      }
    }

    let genList = {};
    genList = result[name];
    return genList;
  }

  public GetGeneratorsByPath(path: any) {
    const generators = this.props.generatorList;
    const result = {};
    for (const index in generators) {
      // tslint:disable-line
      // loop through all generators in list
      const gen = generators[index];
      const path = gen.path; // tslint:disable-line
      if (path) {
        if (result[path]) {
          result[path].push(gen.name);
        } else {
          result[path] = [];
          result[path].push(gen.name);
        }
      }
    }
    let genList = {};
    genList = result[path];
    return genList;
  }

  public CategoryClicked(category: any) {
    const displayName: string= category;
    const nodeType: string = "category";
    const propertyname: string = category;
    this.props.updateNodeData(displayName, propertyname, nodeType);
  }

  // public sibling = (node: any) => {
  //   return (
  //     <NavLink to="/generators/folders" style={{display: "inline-block"}} activeClassName="is-active" onClick={() => this.homeDirectory("Folders")}> <span><FormattedMessage {...translations.folders} /></span> </NavLink> ); {/* tslint:disable-line */}
  // };

  public sibling = () => {
    return (
      <Link to="/generators/folders" style={{display: "inline-block"}} onClick={() => this.homeDirectory("Folders")}>{/* tslint:disable-line */}
        <span style= {{float: "none"}}><FormattedMessage {...translations.folders} /></span>
      </Link>
    );
  };

  public render() {
    // const tree = this.state.tree;

    this.TraverseTree = this.TraverseTree.bind(this);
    const result = this.LoopJSON(); // finding all categories
    const keys = Object.keys(result);
    const output = keys.map(key => {
      return (
        <NavLink to="/generators/categories" key={key} onClick={() => this.CategoryClicked(key)}> {/* tslint:disable-line */}
            {key}
          </NavLink>
      );
    });
    this.ExportPaths();

    return (
      <div className="column is-4-tablet is-3-desktop is-2-widescreen">
        <aside className="menu">
          <p className="menu-label">Menu</p>
          <ul className="menu-list">
            <li>
              <NavLink exact={true} activeClassName="is-active" to="/generators" onClick={() => this.homeDirectory("Generators")}> {/* tslint:disable-line */}
                <span className="icon">
                  <i className="far fa-dice" />
                </span>
                <FormattedMessage {...translations.generators} />
              </NavLink>
            </li>
            <li>
              {/* <li style={{backgroundColor: "#ffffff", borderRadius: "5px", boxShadow: "0 4px 2px -2px lightgray", paddingLeft:"8px"}}> */}
              <Collapsible openedClassName='' 
         
                trigger={
                  <NavLink to="/generators/folders" activeClassName="is-active" style={{display: "inline-block"}} onClick={() => this.homeDirectory("Folders")}>{/* tslint:disable-line */}
                  <span style= {{float: "none"}}><span className="icon"><i className="fa fa-folder" /></span><FormattedMessage {...translations.folders} /></span>
                </NavLink>
                }
                
                triggerWhenOpen={
                  <NavLink to="/generators/folders" activeClassName="is-active" style={{display: "inline-block"}} onClick={() => this.homeDirectory("Folders")}>{/* tslint:disable-line */}
                  <span style= {{float: "none"}}><span className="icon"><i className="fas fa-folder-open" /></span><FormattedMessage {...translations.folders} /></span>
                </NavLink>
                }
   >
              <ul>
                  <Treenode nodes={menuTree} traverseMethod={this.TraverseTree} />
                </ul>
              </Collapsible>
            </li>
            <li>
              <Collapsible trigger={<NavLink activeClassName="is-active" to="/generators/categories" onClick={() => this.homeDirectory("Categories")}>  <span className="icon"><i className="fa fa-list-ul" /></span> <span><FormattedMessage {...translations.categories} /></span> </NavLink>}> {/* tslint:disable-line */}
                <ul>
                  {output}
                </ul>
              </Collapsible>
            </li>
          </ul>


          <p className="menu-label">Administration</p>
          <ul className="menu-list">
            <li>
              <NavLink exact={true} activeClassName="is-active" to="/profilesettings">
                <span className="icon">
                  <i className="fas fa-users-cog" />
                </span>
                <FormattedMessage {...translations.settings} />
              </NavLink>
            </li>
            <li>
            <NavLink exact={true} activeClassName="is-active" to="/bugreport">
                <span className="icon">
                  <i className="fa fa-bug" />
                </span>
                <FormattedMessage {...translations.bugreport} />
                </NavLink>
            </li>
            <li>
              <a onClick={this.handleLogout}>
                <span className="icon">
                  <i className="fa fa-user" />
                </span>
                <FormattedMessage {...translations.logout} />
              </a>
            </li>
          </ul>
        </aside>
      </div>
    );
  }

  private homeDirectory = (home: string) =>  {
    this.props.updateNodeData(home, "/", Type.folder);
  }

}



// WEBPACK FOOTER //
// ./src/Containers/Sidebar/SidebarComponent.tsx